import { get, putJson, postJson } from '@/utils/request';

export function getAccountApi(data) {
  return get('/index/account', data);
}

export function getRechargePopupApi(data) {
  return get('/popup/setting/getRechargePopup', data);
}

export function getMobileListApi(data) {
  return get('/index/users/all_role', data);
}

export function getCountExpireMachine(data) {
  return get(`/popup/setting/ajax-machine/count_expire_machine/${data}`);
}

export function getPersonalSystemRecordApi(data) {
  return get(
    '/system/record/getPersonalSystemRecord',
    data,
  );
}

export function getSystemRecordByIdApi(data) {
  return get(
    `/system/record/getSystemRecordById/${data.id}`,
  );
}

export function readSystemRecordApi(data) {
  return putJson(
    `/system/record/readSystemRecord/${data.id}`,
    data,
  );
}

export function getConsumerComplaintListApi(data) {
  return get(
    '/complaint/record/select',
    data,
  );
}

export function getPendingComplaintCountApi() {
  return get(
    '/complaint/record/pendingCount',
  );
}

export function complaintsReplyApi(data) {
  return postJson(
    '/complaint/record/replyMessage',
    data,
  );
}

export function getComplaintDetailsHistoryApi(data) {
  return get(
    '/complaint/record/getComplaintDetailsHistory',
    data,
  );
}

export function processCompleteApi(data) {
  return postJson(
    '/complaint/record/processComplete',
    data,
  );
}

export function getVerifyCodeApi(data) {
  return get(
    '/login/code/getVerifyCode',
    data,
  );
}

export function checkVerifyCodeApi(data) {
  return postJson(
    '/login/code/checkVerifyCode',
    data,
  );
}

export function sendUpdatePwdCodeApi(data) {
  return get(
    '/login/code/sendUpdatePwdCode',
    data,
  );
}

export function updateAccountPwdApi(data) {
  return putJson(
    '/login/code/updateAccountPwd',
    data,
  );
}

export function getLoginPublicKeyApi(data) {
  return get(
    '/login/code/getLoginPublicKey',
    data,
  );
}

export function getUpdatePwdPopupApi(data) {
  return get(
    '/popup/setting/getUpdatePwdPopup',
    data,
  );
}

export function getPersonalSystemRecordTopPromptApi() {
  return get(
    '/system/record/getSystemRecordReadingTopPrompt',
  );
}

export function getAccountPopupInfoApi(data) {
  return get(
    '/popup/setting/account/popup_info',
    data,
  );
}

export function getWithdrawSignInfoApi(data) {
  return get(
    '/withdraw/sign/info',
    data,
  );
}

export function getActivityEarningsRecordApi(data) {
  return get(
    '/withdraw/platform/subsidy/detail/page',
    data,
  );
}

export function getActivityEarningsRecordTotalApi(data) {
  return get(
    '/withdraw/platform/subsidy/detail/stat',
    data,
  );
}

export function withdrawRegisterSignApi(data) {
  return postJson(
    '/withdraw/register/sign',
    data,
  );
}

export function getWithdrawalRecordApi(data) {
  return get(
    '/withdraw/platform/subsidy/record/page',
    data,
  );
}

export function applyWithdrawApi(data) {
  return postJson(
    '/withdraw/platform/subsidy/withdraw',
    data,
  );
}

export function getNoticeConfigMineApi(data) {
  return get(
    '/notice/config/mine',
    data,
  );
}

export function closeNoticeConfigMineApi(data) {
  return putJson(
    '/notice/config/mine/switch/close',
    data,
  );
}

export function openNoticeConfigMineApi(data) {
  return putJson(
    '/notice/config/mine/switch/open',
    data,
  );
}

export function unbindNoticeConfigMineApi(data) {
  return putJson(
    '/notice/config/mine/unbind',
    data,
  );
}

// 微信小程序 - 协商历史
export function getMiniComplaintRecordApi(data) {
  return get(
    `/complaint/record/miniprogram/detail/${data.complaintId}`,
    data,
  );
}

// 微信小程序 - 回复
export function miniComplaintReplyApi(data) {
  return postJson(
    '/complaint/record/miniprogram/reply',
    data,
  );
}

// 微信小程序 - 商家补充凭证
export function miniComplaintSupplyProofApi(data) {
  return postJson(
    '/complaint/record/miniprogram/supply/proof',
    data,
  );
}

// 微信小程序 - 商家补充凭证
export function miniComplaintSupplyRefundApi(data) {
  return postJson(
    '/complaint/record/miniprogram/supply/refund',
    data,
  );
}

// 微信小程序 - 协商历史
export function getZfbMiniComplaintRecordApi(data) {
  return get(
    `/complaint/record/zfbminiprogram/detail/${data.complaintId}`,
    data,
  );
}

// 支付宝小程序 - 处理投诉
export function zfbMiniComplaintFeedbackApi(data) {
  return postJson(
    '/complaint/record/zfbminiprogram/feedback',
    data,
  );
}

export function wxFastLoginApi(data) {
  return get(
    '/weixin/fastLogin',
    data,
  );
}

export function getWxOauthUserInfoApi(data) {
  return postJson(
    `/weixin/fastLogin/getWxOauthUserInfo/${data.code}`,
  );
}

export function wxFastLoginBindApi(data) {
  return get(
    `/weixin/fastLogin/wxFastLoginBind/${data.accountId}`,
  );
}

export function wxFastLoginUnbindApi(data) {
  return get(
    `/weixin/fastLogin/wxFastLoginUnbind/${data.accountId}`,
  );
}

export function fastLoginBindApi(data) {
  return get(
    'weixin/fastLogin/bind',
    data,
  );
}

// 客服信息查询
export function kefuInfoApi(data) {
  return get(
    '/kefu',
    data,
  );
}

// 客服信息保存
export function updateKefuApi(data) {
  return putJson(
    '/kefu',
    data,
  );
}

export function getTxMapSigApi(data) {
  return postJson(
    '/index/map/sign/qq',
    data,
  );
}

export function lyyMerchantApi(data) {
  return get(
    '/merchant/bill/redirect/lyy',
    data,
  );
}

export function getLyySignUrlApi(data) {
  return get(
    '/merchant/bill/lyy/channel/divide/sign/contact',
    data,
  );
}

export function popupSettingCloseApi(data) {
  return postJson(
    '/popup/setting/close',
    data,
  );
}



// WEBPACK FOOTER //
// ./src/api/user.js